<template>
	<ty-card>
		<div class="ty-color-primary" slot="header">ایجاد تراکنش جدید</div>
		<div class="ty-flex ty-flex-wrap ty-gap-5 ty-space-between">
			<ty-select v-model="type" class="mx-1 mt-auto" label="نوع تراکنش" required>
				<ty-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value" />
			</ty-select>
			<router-link class="mt-auto" :to="{name: 'shop-invoice-editor-create', params: {invoice_type: type}}">
				<ty-button :disabled="!type" class="mx-1" icon="ty-icon-plus">افزودن تراکنش</ty-button>
			</router-link>
		</div>
	</ty-card>
</template>

<script>
	export default {
		data() {
			return {
				type: 'sold',
				types: [
					{label: 'فروش', value: 'sold'},
					{label: 'خرید', value: 'bought'},
				]
			}
		}
	}
</script>